export default "__VITE_ASSET__C_pcZtVH__"